import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import ProfileForm from "./ProfileForm";
import {
  getProfile as getProfileAction,
  updateProfile as updateProfileAction,
} from "../../redux/middleware/profile";
import { getResumes as getResumesAction } from "../../redux/middleware/resume";
import {
  getProfile,
  getProfilesError,
  getProfilesPending,
} from "../../redux/reducers/profile";
import { getResumes } from "../../redux/reducers/resume";

const Container = styled.div`
  font-family: 'Raleway';
`

const Header = styled.div`
  width: 100%;
  float: left;
  padding: 20px 20px 10px;
  background-color: #f6f7f8;
  border-bottom: 1px solid #ccc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`

const HeaderTitle = styled.div`
  width: 100%;
  float: left;
  margin: 0 0 7px;
  font-weight: 700;
  color: #39b54a;
  font-size: 24px;
  padding: 0;
`

class EditProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keywords: "",
      location: "",
    };
  }

  componentWillMount() {
    this.props.getProfile(this.props.profile_id);
    this.props.getResumes(this.props.user);
  }

  shouldComponentRender = () => {
    const { pending, profile } = this.props;
    if (this.pending === false) return false;
    if (profile === undefined) return false;
    return true;
  };

  handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  };

  handleSubmit = (keywords, location) => {
    let url = this.props.getSearchUrl(keywords, location);
    this.props.history.push(url);
  };

  render() {
    if (!this.shouldComponentRender()) return <div>Loading...</div>;

    return (
      <Container className="TabbedPanelsContent TabbedPanelsContentVisible">
        <Header>
          <HeaderTitle>Edit Profile</HeaderTitle>
        </Header>
        <ProfileForm {...this.props} action="update" />
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  error: getProfilesError(state),
  profile: getProfile(state),
  pending: getProfilesPending(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateProfile: updateProfileAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditProfile);
